// This function allow to reference async chunks
__webpack_require__.miniCssF = function(chunkId) {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"341":"814490a2","629":"3e6dc6bf","711":"3513163d","730":"56784b64","836":"3e6dc6bf"}[chunkId] + ".chunk.css";
};